<template>
  <div class="xpt-block">
    <div class="xpt-block__title flex-r">
      <div class="xpt-block__title__warpper flex-1">
        {{title}}
        <slot name="title"></slot>
        <div v-if="more" class="xpt-block__more">
          <a :href="more" :style="moreStyle">更多 ></a>
        </div>
      </div>
    </div>
    <div class="xpt-block__body">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'xptBlock',
  props: {
    title: {
      type: String,
      default: ''
    },
    more: {
      type: String,
      default: ''
    },
    moreStyle: {}
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.xpt-block {
  border-radius: 4px;
  overflow: hidden;
  margin: 0 .1rem;
  margin-bottom: .05rem;
}
.xpt-block__title {
  margin-bottom: 1px;
  /* border-bottom: 1px solid #f5f5f5; */
  position: relative;
  /* padding: 0 20px; */
  padding-right: .06rem;
  height: .43rem;
  font-weight: 700;
  line-height: .43rem;
  font-size: 15px;
  color: #333333;
  background: #fff;
}
.xpt-block__title img {
  display: inline-block;
  vertical-align: middle;
}
.xpt-block__title img:nth-child(1) {
  width: .13rem;
  /* position: relative;
  top: -0.02rem; */
}
.xpt-block__title img:nth-child(2) {
  width: .63rem;
  margin: 0 .15rem;
}
.xpt-block__title img:nth-child(3) {
  width: .15rem;
}
.xpt-block__title__warpper {
  position: relative;
}
/* .xpt-block__title::before {content: ' '; position: absolute;top: 15px;left: 10px; width: 2px;background: red;height: 14px;} */
.xpt-block__body {
  -webkit-transform: rotate(0deg);
          transform: rotate(0deg)
}
.xpt-block__more {
  font-size: .12rem;

  position: absolute;
  right: .06rem;
  top: 0;
}
.xpt-block__more a {
  color: #F02E89;
}
</style>
